import styled, { css } from 'styled-components'
import BaseModal from '../Modal'
import { media } from 'sidecar-design-library'

export const Modal = styled(BaseModal)`
  ${({ minWidth }) => css`
    ${minWidth &&
    `
      min-width: ${p.minWidth};
    `}

    ${media.tabletAndBelow`
      min-width: 80%;
      width: 80%;
    `}
  
    ${media.mobile`
      min-width: 100%;
      width: 100%;
    `}
  `}
`
